import {useFieldArray, useFormContext, useFormValue} from '@yandex-delivery/form'
import {useCallback} from 'react'

import type {Order} from 'src/shared/types'

import type {Props} from './types'
import {toDestinationPoint} from './utils/to-destination-point'

export function useDestinationPoints({name}: Props) {
  const {control} = useFormContext()
  const {fields, append, remove} = useFieldArray({control, name})
  const verticalName = useFormValue<Order, 'offerFlow.vertical.name'>('offerFlow.vertical.name')

  const isAddButtonVisible = verticalName === 'express' || verticalName === 'courier' || verticalName === 'cargo'
  const destinations = verticalName === 'night' ? fields.slice(0, 1) : fields

  const addDestinationPointHandler = useCallback(() => {
    append(toDestinationPoint(undefined))
  }, [append])

  return {
    isAddButtonVisible,
    destinations,
    addDestinationPoint: addDestinationPointHandler,
    removeDestinationPoint: remove,
  }
}
